<template>
  <div class="mx-5 mt-5">
    <!-- Overlay -->
    <v-overlay absolute :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />

    <!-- CARD TARTUFLANGHE -->
    <v-card>
      <v-toolbar color="indigo" dense>
        <v-toolbar-title class="white--text">
          Master Label List
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn @click="clickDialogAggTar" small v-bind="attrs" v-on="on">
              <v-icon color="primary"> mdi-plus </v-icon>
            </v-btn>
          </template>
          <span>Add label</span>
        </v-tooltip>
        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-show="show_filtri == false"
              @click="clickShowFilters"
              class="mr-4"
              small
              v-bind="attrs"
              v-on="on"
            >
              <v-icon color="purple lighter-2"> mdi-filter </v-icon>
            </v-btn>
          </template>
          <span>Show filters</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-show="show_filtri === true"
              @click="resetFiltro"
              small
              v-bind="attrs"
              v-on="on"
              ><v-icon color="purple lighter-2">mdi-filter-off</v-icon></v-btn
            >
          </template>
          <span>Hide filters</span>
        </v-tooltip>

        <v-spacer></v-spacer>

        <!-- <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
          dark
          color="cyan"
        ></v-text-field>

        <v-spacer></v-spacer> -->

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn small @click="goBack" v-bind="attrs" v-on="on">
              <v-icon color="error"> mdi-keyboard-backspace </v-icon>
            </v-btn>
          </template>
          <span>Back</span>
        </v-tooltip>
      </v-toolbar>
      <v-row align="center" justify="center" v-show="show_filtri" class="mt-2">
        <v-col>
          <v-autocomplete
            class="mr-6"
            background-color="#ffffff"
            @change="filtra"
            dense
            hide-details
            :items="lista_report_tar.filter((i) => i.cod_label != null)"
            :item-text="(item) => item.cod_label"
            :item-value="(item) => item.cod_label"
            label="Label Code"
            style="display: inline-block; max-width: 350px"
            v-model="cod_label_search"
          >
            <template v-slot:append>
              <v-icon
                class="ml-2"
                @click="
                  cod_label_search = '';
                  filtra();
                "
                color="primary"
                >{{ cod_label_search == "" ? "mdi-filter" : "mdi-filter-off" }}
              </v-icon>
            </template>
          </v-autocomplete>

          <v-autocomplete
            background-color="#ffffff"
            @change="filtra"
            dense
            hide-details
            :items="lista_report_tar.filter((i) => i.versione != null)"
            :item-text="(item) => item.versione"
            :item-value="(item) => item.versione"
            label="Version"
            style="display: inline-block; max-width: 350px"
            v-model="version_search"
          >
            <template v-slot:append>
              <v-icon
                class="ml-2"
                @click="
                  version_search = '';
                  filtra();
                "
                color="primary"
                >{{ version_search == "" ? "mdi-filter" : "mdi-filter-off" }}
              </v-icon>
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>
      <v-data-table
        class="mt-3"
        :search="search"
        :items="lista_tabella"
        :headers="headers_etichette_tar"
      >
        <!-- Bottone dialog di dettaglio -->
        <template v-slot:[`item.dettaglio`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="clickShowDetail(item)"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="primary"> mdi-magnify </v-icon>
              </v-btn>
            </template>
            <span>Show detail</span>
          </v-tooltip>
        </template>
        <!-- Bottone dialog di modifica -->
        <template v-slot:[`item.edita`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="clickModificaLabel(item)"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="primary"> mdi-pencil </v-icon>
              </v-btn>
            </template>
            <span>Edit</span>
          </v-tooltip>
        </template>
        <!-- Bottone dialog storico -->
        <template v-slot:[`item.storico`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="clickShowHistory(item)"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="primary"> mdi-bookshelf </v-icon>
              </v-btn>
            </template>
            <span>Show history</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>

    <!-- Dialog Add Tartuflanghe -->
    <v-dialog
      persistent
      v-model="dialog_add_tar"
      :width="e1 == 2 ? '95%' : '60%'"
    >
      <v-card>
        <v-toolbar dense color="indigo" class="white--text">
          <v-toolbar-title>{{
            label.id_label != -1 ? "Edit Label" : "Add Label"
          }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :disabled="e1 == 1"
                class="mr-2"
                @click="previousStep(e1)"
                v-bind="attrs"
                v-on="on"
                small
              >
                <v-icon color="primary"> mdi-arrow-left </v-icon>
              </v-btn>
            </template>
            <span>Indietro</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="e1 == 4"
                @click="clickSaveLabel"
                v-bind="attrs"
                v-on="on"
                small
              >
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
              <v-btn
                v-else
                :disabled="label.base64 == '' || label.cod_label == ''"
                @click="nextStep(e1)"
                v-bind="attrs"
                v-on="on"
                small
              >
                <v-icon color="primary"> mdi-arrow-right </v-icon>
              </v-btn>
            </template>
            <span>{{ e1 == 4 ? "Save" : "Continue" }}</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="clickChiudiDialogAggTar"
                v-bind="attrs"
                v-on="on"
                small
              >
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Close</span>
          </v-tooltip>
        </v-toolbar>
        <v-stepper v-model="e1">
          <v-stepper-header>
            <template v-for="n in steps">
              <v-stepper-step
                color="success"
                :key="`${n}-step`"
                :complete="e1 > n"
                :step="n"
              >
                Step {{ n }}
              </v-stepper-step>

              <v-divider v-if="n !== steps" :key="n"></v-divider>
            </template>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content
              v-for="_n in steps"
              :key="`${_n}-content`"
              :step="_n"
            >
              <div v-if="_n == 1" class="mb-12 mt-4">
                <v-row justify="center" align="center">
                  <v-col cols="6">
                    <v-text-field
                      v-model="label.cod_label"
                      label="Nome report"
                      prepend-icon="mdi-file"
                    />
                  </v-col>
                  <v-col>
                    <v-btn text color="primary" @click="uploadReportModel">
                      <v-icon class="mr-5">mdi-upload</v-icon>
                      {{
                        label.base64 != "" ? "Cambia modello" : "Carica modello"
                      }}
                    </v-btn>
                  </v-col>
                  <v-col v-if="label.base64">
                    <v-icon color="success"> mdi-check </v-icon>
                  </v-col>
                </v-row>
              </div>
              <div
                v-if="_n == 2 && label.modello != undefined && e1 == 2"
                class="mb-12"
              >
                <QuickLabelDetail
                  v-if="label.modello != null"
                  ref="label_detail"
                  @getItemsTextObj="getItemsTextObj"
                  :etichetta="label.modello"
                  :campi="label.campi"
                  :show_off="true"
                  :show_tab_off="false"
                  :key="key_reportpage"
                />
              </div>
              <div
                v-if="_n == 3 && label.modello != undefined && e1 == 3"
                class="mb-12"
              >
                <!-- <QueryEditor v-model="query_sel" :template="[]" /> -->
                <v-row class="mt-4">
                  <v-col cols="5">
                    <v-select
                      :items="lista_query"
                      item-text="titolo"
                      item-value="id_query"
                      dense
                      v-model="label.query_dictionary"
                      label="Query Dictionary"
                      @change="logItem(label)"
                    />
                  </v-col>
                  <!-- <v-col cols="1">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" small>
                          <v-icon color="primary">mdi-database-plus</v-icon>
                        </v-btn>
                      </template>
                      <span>Aggiungi una query dictionary</span>
                    </v-tooltip>
                  </v-col> -->
                  <v-col cols="5">
                    <v-select
                      :items="lista_query"
                      item-text="titolo"
                      item-value="id_query"
                      v-model="label.query_campi"
                      dense
                      label="Query Campi Traduzione"
                    />
                  </v-col>
                  <v-col cols="2">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          @click="apriDialogQueryToTable"
                          v-bind="attrs"
                          v-on="on"
                          small
                        >
                          <v-icon color="primary">mdi-database-plus</v-icon>
                        </v-btn>
                      </template>
                      <span>Aggiungi una query</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </div>
              <div v-if="_n == 4" class="mb-3" style="font-size: 18px">
                Sicuro di voler salvare
                <span style="font-weight: bold">{{ label.cod_label }}</span
                >?
              </div>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card>
    </v-dialog>

    <!-- Dialog History Tartuflanghe -->
    <v-dialog
      :retain-focus="false"
      persistent
      v-model="dialog_show_history"
      width="50%"
    >
      <v-card>
        <v-toolbar dense color="indigo" class="white--text">
          <v-toolbar-title>{{ label.cod_label }} History</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="clickChiudiDialogHistory"
                v-bind="attrs"
                v-on="on"
                small
              >
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Close</span>
          </v-tooltip>
        </v-toolbar>
        <v-data-table :items="lista_storico" :headers="headers_history">
          <!-- Bottone dialog di dettaglio -->
          <template v-slot:[`item.dettaglio`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="clickShowDetail(item)"
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="primary"> mdi-magnify </v-icon>
                </v-btn>
              </template>
              <span>Show detail</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>

    <!-- Dialog Dettaglio Tartuflanghe -->
    <v-dialog :key="key_reportpage" persistent v-model="dialog_show_detail">
      <v-card>
        <v-toolbar dense color="indigo" class="white--text">
          <v-toolbar-title>Detail - {{ label.cod_label }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="clickChiudiDialogDetail"
                v-bind="attrs"
                v-on="on"
                small
              >
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Close</span>
          </v-tooltip>
        </v-toolbar>
        <v-row align="center" justify="center" class="ma-2">
          <v-col>
            <QuickLabelDetail
              ref="label_detail"
              :etichetta="label.modello"
              :show_off="true"
              :show_tab_off="true"
              :key="key_reportpage"
            />
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>

    <!-- Dialog Query to Table -->
    <v-dialog persistent v-model="dialog_query_table" width="80%">
      <v-card>
        <v-toolbar dense color="indigo" class="white--text">
          <v-toolbar-title>Lista Query</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="closeDialogQueryToTable"
                v-bind="attrs"
                v-on="on"
                small
              >
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Close</span>
          </v-tooltip>
        </v-toolbar>
        <v-container class="ma-2">
          <TabellaCustomAdapter :from_label="from_label" />
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import { FrxToJson, JsonToFrx } from "./FrxJsonConverter";
import QuickLabelDetail from "@/views/LABEL/QuickLabelDetail";
import TabellaCustomAdapter from "@/components/TABELLA_CUSTOM/TabellaCustomAdapter.vue";
// import QueryEditor from "@/components/GRAPH/Dashboard/Editor/QueryParser/QueryEditor.vue";

class Label {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setControlli();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setControlli();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }

  // Metodo per resettare tutte i campi
  reset() {
    const campi = this.setControlli();
    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setControlli() {
    const campi = [
      { nome: "id_label", default_val: -1 },
      { nome: "new_master", default_val: false },
      { nome: "cod_label", default_val: "" },
      { nome: "modello", default_val: null },
      { nome: "base64", default_val: "" },
      { nome: "campi", default_val: [] },
      { nome: "root", default_val: "" },
      { nome: "query", default_val: "" },
      { nome: "query_dictionary", default_val: "" },
      { nome: "query_campi", default_val: "" },
      { nome: "validita", default_val: 1 },
    ];
    return campi;
  }
}

export default {
  name: "",
  components: {
    SnackbarQV,
    QuickLabelDetail,
    // QueryEditor,
    TabellaCustomAdapter,
  },
  props: {},
  data() {
    return {
      // Variabili d'appoggio
      cliente: "",
      cod_label_search: "",
      version_search: "",
      e1: 1,
      key_reportpage: 0,
      label: new Label(),
      obj_label: null,
      query_sel: { query: "Inserisci la query" },
      search: "",
      steps: 4,

      // Modal
      dialog_add: false,
      dialog_add_tar: false,
      dialog_show_detail: false,
      dialog_show_history: false,
      dialog_query_table: false,
      from_label: true,
      overlay: false,
      show_filtri: false,

      // Array
      headers_etichette_tar: [
        {
          text: "Detail",
          value: "dettaglio",
          sortable: false,
          align: "center",
        },
        {
          text: "Edit",
          value: "edita",
          sortable: false,
          align: "center",
        },
        {
          text: "History",
          value: "storico",
          sortable: false,
          align: "center",
        },
        {
          text: "Label Code",
          value: "cod_label",
        },
        {
          text: "Report Code",
          value: "cod_report",
        },
        {
          text: "Version",
          value: "versione",
        },
      ],
      headers_traduzione: [
        {
          text: "Original",
          value: "originale",
          sortable: false,
        },
        {
          text: "Translation",
          value: "traduzione",
          sortable: false,
        },
      ],
      headers_history: [
        {
          text: "Detail",
          value: "dettaglio",
          sortable: false,
          align: "center",
        },
        {
          text: "Label Code",
          value: "cod_label",
          sortable: false,
        },
        {
          text: "Version",
          value: "versione",
          sortable: false,
        },
        {
          text: "Creation Date",
          value: "data_creazione",
          sortable: false,
        },
      ],

      lista_etichette: [],
      lista_report_tar: [],
      lista_tabella: [],
      lista_storico: [],
      lista_query: [],
    };
  },
  computed: {},
  methods: {
    logItem(item) {
      console.log("item ==> ", item);
    },
    apriDialogQueryToTable() {
      this.dialog_query_table = true;
    },
    closeDialogQueryToTable() {
      this.getListaQuery();
      this.dialog_query_table = false;
    },
    clickChiudiDialogAgg() {
      this.e1 = 1;
      this.dialog_add = false;
    },
    clickChiudiDialogAggTar() {
      this.label = new Label();
      this.query_sel = { query: "Inserisci la query" };
      this.e1 = 1;
      this.dialog_add_tar = false;
    },
    clickChiudiDialogDetail() {
      this.label = new Label();
      this.dialog_show_detail = false;
    },
    clickChiudiDialogHistory() {
      this.label = new Label();
      this.dialog_show_history = false;
    },
    clickDialogAggTar() {
      this.dialog_add_tar = true;
      this.$nextTick(() => {
        this.key_reportpage = this.key_reportpage == 0 ? 1 : 0;
      });
    },
    clickModificaLabel(item) {
      this.label = new Label(item);
      this.query_sel.query = item.query;
      this.label.query_campi = item.id_query_traduzione;
      this.label.query_dictionary = item.id_query_dictionary;
      this.getMasterDetail(item);

      // this.lista_query.forEach(e => {
      //   if (e.query1[0].query == this.label.item) {
      //     console.log("match query", e, this.label);
      //     this.label.query_dictionary = e.id_query;
      //   }
      // })

      this.dialog_add_tar = true;
    },
    clickSaveLabel() {
      this.overlay = true;

      let label_tmp = JsonToFrx(this.label.modello, this.label.base64);

      let arr = [];

      if (this.label.campi != null) {
        this.label.campi.forEach((e) => {
          let item = {
            id_campo: e.id != null ? e.id : e.id_campo,
            editabile: e.editabile == true ? 1 : 0,
          };
          arr.push(item);
        });
      }

      const request = {
        controller: "Label",
        method: "PUT",
        richiesta: {
          action: "setmasterdetail",
          token: localStorage.user_token,
          new_master: this.label.new_master,
          cod_label: this.label.cod_label,
          modello: label_tmp,
          id_label: this.label.id_label,
          campi: arr,
          // query: this.query_sel.query,
          id_query_traduzione: this.label.query_campi,
          id_query_dictionary: this.label.query_dictionary,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          console.log(res);
          this.getLabelTar();
          this.label = new Label();
          this.e1 = 1;
          this.dialog_add_tar = false;
          this.overlay = false;
          this.$refs.SnackbarQV.print("success", "Label salvato con successo");
        })
        .catch((err) => {
          this.overlay = false;
          this.$refs.SnackbarQV.print(
            "error",
            `${JSON.parse(err.response.data.message).result}.`
          );
        });
    },
    async clickShowDetail(item) {
      this.label = new Label(item);
      await this.getMasterDetail(item);

      this.$nextTick(() => {
        this.key_reportpage = this.key_reportpage == 0 ? 1 : 0;
      });

      this.dialog_show_detail = true;
    },
    clickShowFilters() {
      this.show_filtri = true;
    },
    clickShowHistory(item) {
      this.label = new Label(item);
      this.getHistory();
      this.dialog_show_history = true;
    },
    getHistory() {
      const request = {
        controller: "Label",
        method: "POST",
        richiesta: {
          action: "getmasterhistory",
          token: localStorage.user_token,
          root: this.label.root,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.lista_storico = res.data;
            this.lista_storico.forEach((e) => {
              e.data_creazione = e.data_creazione.replace("T", " ");
            });
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              `Criticità rilevata, codice stato: ${res.status}.`
            );
          }
        })
        .catch((err) => {
          this.$refs.SnackbarQV.print(
            "error",
            `${JSON.parse(err.response.data.message).result}.`
          );
        });
    },
    getListaQuery() {
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getquerydettaglio",
          token: localStorage.user_token,
          // tipologia: this.tabella_sel.modulo,
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.data.result.query.length != 0) {
          this.lista_query = res.data.result.query;
        } else {
          console.log("nessuna tabella presente");
        }
      });
    },
    // getObjFromXml(arg) {
    //   // Base64 to Xml
    //   arg = decodeURIComponent(decodeURIComponent(escape(atob(arg))));

    //   console.log("arg 1", arg);

    //   // Elimino l'intestazione xml
    //   arg = arg.replace(new RegExp("(<\\?)(.*?)(\\?>)", "gm"), "");

    //   // Elimino il tag report
    //   arg = arg.replace(new RegExp("(<Report)(\\s|>)(.*?)(>)", "gm"), "");
    //   arg = arg.replace(new RegExp("(</Report>)", "gm"), "");

    //   // Elimino tutto quello che sta nel tag Dictionary
    //   arg = arg.replace(
    //     new RegExp("(<Dictionary)(.*?)(</Dictionary>)", "gm"),
    //     ""
    //   );

    //   // Trasformo i name in attributi
    //   arg = arg.replace(
    //     new RegExp(`="/>`, "gm"),
    //     `EqualQuotationToBePreserved/>`
    //   );
    //   arg = arg.replace(
    //     new RegExp(`=" `, "gm"),
    //     `EqualQuotationToBePreserved `
    //   );
    //   arg = arg.replace(new RegExp(`="`, "gm"), `MyRegExp:MyRegExp`);
    //   arg = arg.replace(new RegExp(`" `, "gm"), `", "`);
    //   arg = arg.replace(new RegExp(`MyRegExp:MyRegExp`, "gm"), `":"`);

    //   // Trasformo i tag di apertura e chiusura aperture e chiusure di oggetto
    //   arg = arg.replace(
    //     new RegExp("(<ReportPage)", "gm"),
    //     `{"tipo": "ReportPage",`
    //   );
    //   arg = arg.replace(new RegExp("(</ReportPage>)", "gm"), `]}`);
    //   arg = arg.replace(
    //     new RegExp("(<ReportTitleBand)", "gm"),
    //     `{"tipo": "ReportTitleBand",`
    //   );
    //   arg = arg.replace(new RegExp("(</ReportTitleBand>)", "gm"), `]}`);
    //   arg = arg.replace(
    //     new RegExp("(<PageHeaderBand)", "gm"),
    //     `{"tipo": "PageHeaderBand",`
    //   );
    //   arg = arg.replace(new RegExp("(</PageHeaderBand>)", "gm"), `]}`);
    //   arg = arg.replace(
    //     new RegExp("(<DataBand)", "gm"),
    //     `{"tipo": "DataBand",`
    //   );
    //   arg = arg.replace(new RegExp("(</DataBand>)", "gm"), `]}`);
    //   arg = arg.replace(
    //     new RegExp("(<BarcodeObject)", "gm"),
    //     `{"tipo": "BarcodeObject",`
    //   );
    //   arg = arg.replace(new RegExp("(</BarcodeObject>)", "gm"), `]}`);
    //   arg = arg.replace(
    //     new RegExp("(<TextObject)", "gm"),
    //     `{"tipo": "TextObject",`
    //   );
    //   arg = arg.replace(new RegExp("(</TextObject>)", "gm"), `]}`);
    //   arg = arg.replace(
    //     new RegExp("(<Highlight)", "gm"),
    //     `{"tipo": "Highlight",`
    //   );
    //   arg = arg.replace(new RegExp("(</Highlight>)", "gm"), `]}`);
    //   arg = arg.replace(
    //     new RegExp("(<Condition )", "gm"),
    //     `{"tipo": "Condition", "`
    //   );
    //   arg = arg.replace(new RegExp("(</Condition>)", "gm"), `]}`);
    //   arg = arg.replace(
    //     new RegExp("(<PictureObject)", "gm"),
    //     `{"tipo": "PictureObject",`
    //   );
    //   arg = arg.replace(new RegExp("(</PictureObject>)", "gm"), `]}`);
    //   arg = arg.replace(
    //     new RegExp("(<LineObject)", "gm"),
    //     `{"tipo": "LineObject",`
    //   );
    //   arg = arg.replace(new RegExp("(</LineObject>)", "gm"), `]}`);
    //   arg = arg.replace(
    //     new RegExp("(<PageFooterBand)", "gm"),
    //     `{"tipo": "PageFooterBand",`
    //   );
    //   arg = arg.replace(new RegExp("(</PageFooterBand>)", "gm"), `]}`);

    //   arg = arg.replace(
    //     new RegExp(`EqualQuotationToBePreserved `, "gm"),
    //     `=", "`
    //   );
    //   arg = arg.replace(
    //     new RegExp(`EqualQuotationToBePreserved/>`, "gm"),
    //     `="}`
    //   );
    //   arg = arg.replace(new RegExp(` Name`, "gm"), ` "Name`);
    //   arg = arg.replace(new RegExp(`/>`, "gm"), `, "children":[]},`);
    //   arg = arg.replace(new RegExp(`>`, "gm"), `, "children": [`);
    //   arg = arg.replace(new RegExp(`,}`, "gm"), `},`);
    //   arg = arg.replace(new RegExp(`,]`, "gm"), `]`);
    //   arg = arg.replace(new RegExp(`}{`, "gm"), `},{`);
    //   arg = arg.replace(new RegExp(`,,`, "gm"), `,`);
    //   arg = arg.replace(new RegExp(`},}`, "gm"), `}}`);
    //   arg = arg.slice(0, -1);

    //   console.log("arg 2", arg);

    //   // arg = JSON.parse(arg);

    //   return arg;
    // },
    getItemsTextObj(arg) {
      console.log("arg", arg);
      if (this.label.campi != null) {
        this.label.campi.forEach((c) => {
          arg.forEach((e) => {
            if (c.id_campo == e.id) {
              c.editabile = e.editabile;
              c.text = e.text;
            }
          });
        });
      } else {
        this.label.campi = [];
        arg.forEach((e) => {
          let obj = {
            id_campo: e.id,
            editabile: e.editabile,
            text: e.text,
          };

          this.label.campi.push(obj);
        });
      }
    },
    getMasterDetail(item) {
      console.log("item", item);
      return new Promise((resolve, reject) => {
        const request = {
          controller: "Label",
          method: "POST",
          richiesta: {
            action: "getmasterdetail",
            token: localStorage.user_token,
            id_label: item.id_label,
          },
        };

        this.$store
          .dispatch("api", request)
          .then((res) => {
            if (res.status === 200) {
              this.label.campi = res.data.campi;
              this.label.base64 = res.data.report[0].modello;
              this.label.modello = FrxToJson(this.label.base64);
              // this.dialog_add_tar = true;
            } else {
              this.$refs.SnackbarQV.print(
                "orange",
                `Criticità rilevata, codice stato: ${res.status}.`
              );
            }
            resolve();
          })
          .catch((err) => {
            console.error(err);
            this.$refs.SnackbarQV.print(
              "error",
              `${JSON.parse(err.response.data.message).result}.`
            );
            reject(err);
          });
      });
    },
    getLabelTar() {
      const request = {
        controller: "Label",
        method: "POST",
        richiesta: {
          action: "getreportlabel",
          token: localStorage.user_token,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            res.data.forEach((e) => {
              let encoded = JSON.parse(atob(e.query));
              let query = "";
              if (encoded[0]) query = atob(encoded[0].query);
              e.query = query;
            });
            this.lista_report_tar = res.data;
            this.lista_tabella = this.lista_report_tar;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              `Criticità rilevata, codice stato: ${res.status}.`
            );
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            `Errore di comunicazione col server, impossibile caricare i dati.` //${JSON.parse(err.response.data.message).result}
          );
        });
    },
    goBack() {
      this.$router.push("/home");
    },
    filtra() {
      let items_etichette_tmp = [];
      this.lista_report_tar.forEach((elem) => {
        items_etichette_tmp.push(elem);
      });

      // Filtro il nome della intervento
      if (this.cod_label_search != "") {
        // Faccio un array temporaneo
        const res = [];
        /* Filtro gli elementi visualizzati dopo i passaggi precedenti
         * e li inserisco in "res". */
        items_etichette_tmp.forEach((elem) => {
          if (elem.cod_label == this.cod_label_search) {
            res.push(elem);
          }
        });
        // Modello la risposta provvisoria su "res".
        items_etichette_tmp = res;
      }

      if (this.version_search != "") {
        // Faccio un array temporaneo
        const res = [];
        /* Filtro gli elementi visualizzati dopo i passaggi precedenti
         * e li inserisco in "res". */
        items_etichette_tmp.forEach((elem) => {
          if (elem.versione == this.version_search) {
            res.push(elem);
          }
        });
        // Modello la risposta provvisoria su "res".
        items_etichette_tmp = res;
      }

      this.lista_tabella = items_etichette_tmp;
    },
    resetFiltro() {
      // Resetto i filtri
      this.cod_label_search = "";
      this.version_search = "";

      // Nascondo i filtri
      this.show_filtri = false;

      this.lista_tabella = this.lista_report_tar;
    },
    nextStep(n) {
      if (n === this.steps) {
        this.e1 = 1;
      } else {
        this.e1 = n + 1;
      }
    },
    previousStep(n) {
      // if (n === this.steps) {
      //   this.e1 = 1;
      // } else {
      //   this.e1 = n - 1;
      // }
      this.e1 = n - 1;
    },
    uploadReportModel() {
      this.label.new_master = true;
      this.label.campi = null;
      this.key_reportpage = this.key_reportpage == 1 ? 0 : 1;
      const that = this;
      const input = document.createElement("input");
      input.setAttribute("type", "file");
      input.setAttribute("accept", ".frx");
      input.onchange = function () {
        const reader = new FileReader();
        reader.onload = function () {
          that.label.base64 = btoa(encodeURIComponent(reader.result));
          that.label.modello = FrxToJson(that.label.base64);
        };
        reader.readAsText(input.files[0]);
      };
      input.click();
    },
  },
  created() {},
  mounted() {
    this.cliente = localStorage.nominativo;
    this.getLabelTar();
    this.getListaQuery();
  },
  watch: {
    steps(val) {
      if (this.e1 > val) {
        this.e1 = val;
      }
    },
  },
};
</script>
<style scoped>
</style>